import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { Link } from "react-router-dom";
import RiskPill, { SplitRiskPill } from "../../../common/RiskPill";
import { ReactComponent as RefreshIcon } from "../../../../assets/icons/RefreshIcon.svg";
import {
  alterChatStatus,
  alterSSRIStatus,
  fetchCaregiverLogic,
  handleMrnNumber,
  toggleSSRIStatusLogic,
} from "../../../../store/features/patient/patientSlice";
import { toggleChatStatusLogic } from "../../../../store/features/chat/chatSlice";
import moment from "moment";
import { getFullName, notify, smartJoin } from "../../../../util/helpers";
import PatientLoader from "../../../common/PatientLoader";
import ResetFlagModal from "./ResetFlagModal";
import { isEmptyObject } from "jquery";
import RiskModal from "../RiskModal/RiskModal";
import AssignPhysicianModal from "./AssignPhysicianModal";

const BasicInformation = (props) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const { user, staffData,mrnNumberLoading } = useSelector((state) => state.app);
  const {
    loading,
    singlePatientData,
    caregiverLoading,
    caregiverError,
    caregiverData,
  } = useSelector((state) => state.patient);
  const { bhiLoading, bhiData } = useSelector((state) => state.bhi);
  const [resetFlagModal, showResetFlagModal] = useState(false);
  const [assignPhysicianModal, showAssignPhysicianModal] = useState(false);
  // const [managedBy, setManagedBy] = useState(getFullName(user));
  const [managedBy, setManagedBy] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  //Chat Toggle
  const [chatStatus, setChatStatus] = useState(singlePatientData?.rose_chat);
  const [chatLoading, setChatLoading] = useState(false);
  //SSRI Toggle
  const [ssriStatus, setSsriStatus] = useState(singlePatientData?.ssri_status);
  const [ssriLoading, setSsriLoading] = useState(false);
  // MRN Toggle
  const [editMrn,setEditMrn]=useState(false);
  const [mrnNumber,setMrnNumber]=useState("");

  //Handle Deleted Email
  const [userEmail, setUserEmail] = useState("");
  useEffect(() => {
    if (!loading && !bhiLoading && !caregiverLoading) {
      setIsLoading(false);
    }
  }, [loading, bhiLoading, caregiverLoading]);

  const getManagedBy = () => {
    try {
      // const allManagers = [
      //   user?.id,
      //   ...singlePatientData?.shared_with_clinical_staff,
      // ];
      const allManagers = singlePatientData?.shared_with_clinical_staff?.length
      ? [...singlePatientData.shared_with_clinical_staff]
      : [];
      let sharedManagers = staffData
        .filter((staff) => {
          if (allManagers.includes(staff.id)) {
            return staff;
          }
        })
        .map((staff) => {
          return getFullName(staff);
        });

      sharedManagers = smartJoin(sharedManagers);
      return sharedManagers;
    } catch (e) {
      return getFullName(user);
    }
  };
  const handleChatToggle = () => {
    if (chatLoading) {
      return;
    }
    setChatLoading(true);

    toggleChatStatusLogic({
      chatStatus: !chatStatus,
      patientID: singlePatientData?.id,
    })
      .then((res) => {
        if (res.status === 200) {
          notify(`Chat ${chatStatus ? "disabl" : "enabl"}ed!`, "info");
          dispatch(alterChatStatus(!chatStatus));
          setChatStatus(!chatStatus);
          setChatLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        notify("Something went wrong! Try again later!", "error");
        setChatLoading(false);
      });
  };

  const handleMrn = async() => {
    const data  = {
      mrnNumber :mrnNumber,
      patientID:singlePatientData?.id
    }
    try {
      await dispatch(handleMrnNumber(data));
      setEditMrn(false);
    } catch (error) {
      setEditMrn(false);
    }
  };
  
  const handleSSRIToggle = () => {
    if (ssriLoading) {
      return;
    }
    setSsriLoading(true);

    toggleSSRIStatusLogic({
      patientID: singlePatientData?.id,
      ssriStatus: !ssriStatus,
    })
      .then((res) => {
        if (res.status === 204) {
          notify(`SSRI ${ssriStatus ? "disabl" : "enabl"}ed!`, "info");
          dispatch(alterSSRIStatus(!ssriStatus));
          setSsriStatus(!ssriStatus);
          setSsriLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        notify("Something went wrong! Try again later!", "error");
        setSsriLoading(false);
      });
  };

  useEffect(() => {
    if (user) {
      const tempManagedBy = getManagedBy();
      setManagedBy(tempManagedBy);
    }
    if (!isEmptyObject(singlePatientData)) {
      if (!singlePatientData?.caregiver_id === null)
        console.log("singlePatientData?.caregiver_id : ",singlePatientData?.caregiver_id)
        dispatch(fetchCaregiverLogic(singlePatientData?.caregiver_id));
      const formattedEmail = singlePatientData?.email.split("_deleted_");
      if (formattedEmail.length > 1) {
        setUserEmail(`${formattedEmail[0]} [DELETED]`);
      } else {
        setUserEmail(formattedEmail[0]);
      }
    }
  }, [user, singlePatientData]);
  return (
    <CardLayout
      className="col-sm-12 col-md-5 col-lg-5"
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      <RiskModal setIsOpen={setIsModalOpen} modalIsOpen={isModalOpen} />
      <ResetFlagModal
        modalIsOpen={resetFlagModal}
        setIsOpen={showResetFlagModal}
        patientId={props?.patientId}
      />
      <AssignPhysicianModal
        modalIsOpen={assignPhysicianModal}
        setIsOpen={showAssignPhysicianModal}
        patientId={props?.patientId}
      />
      {isLoading ? (
        <PatientLoader />
      ) : (
        <div className="container-fluid px-4 pb-4">
          <div className="d-flex justify-content-between mb-4 ">
            <label style={{ fontSize: "1.3rem" }}>Basic Information</label>
            <small>
              <Link
                to={`/patients/basic/${singlePatientData.id}`}
                style={{ color: "#395e9d", textDecoration: "underline" }}
              >
                {/* View more {">"} */}
              </Link>
            </small>
          </div>
          <div className="">
            <div className="d-flex justify-content-start my-4">
              <label style={{ width: "40%" }} className="muted-text">
                Email Address
              </label>
              <label style={{ width: "60%" }}>{userEmail}</label>
            </div>
            <div className="d-flex justify-content-start my-4">
              <label style={{ width: "40%" }} className="muted-text">
                Phone No.
              </label>
              <label style={{ width: "60%" }}>
                {singlePatientData?.cell_number || "Not Available"}
              </label>
            </div>
            <div className="d-flex justify-content-start my-4">
              <label style={{ width: "40%" }} className="muted-text">
                Date of Birth
              </label>
              <label style={{ width: "60%" }}>
                {singlePatientData?.date_of_birth
                  ? `${moment(singlePatientData?.date_of_birth).format(
                      "MM - DD - YYYY"
                    )} (${moment().diff(
                      singlePatientData?.date_of_birth,
                      "years"
                    )} yrs old)`
                  : "Unavailable"}
              </label>
            </div>
            <div className="d-flex justify-content-start my-4">
              <label style={{ width: "40%" }} className="muted-text">
                Managed By
              </label>
              <label style={{ width: "60%" }}>{managedBy}</label>
            </div>
            <div className="d-flex justify-content-start my-4">
              <label style={{ width: "40%" }} className="muted-text">
                MRN Number
              </label>
              {!editMrn && <div className="d-flex"><label style={{paddingRight:""}}>{singlePatientData?.mrn_number}</label>
              <div className="edit-icon" onClick={()=>{setEditMrn(true);setMrnNumber(singlePatientData?.mrn_number);}}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#4D6F9F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 20h9" />
                  <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                </svg>
                Edit
              </div></div>}
              {editMrn && (
                  <div className="d-flex align-items-center gap-2 mt-2">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      style={{ maxWidth: "200px" }}
                      value={mrnNumber?mrnNumber:""}
                      onChange={(e) => setMrnNumber(e.target.value)}
                      placeholder="Enter MRN"
                    />
                    <button className="save-button" disabled={mrnNumberLoading} onClick={()=>{handleMrn();}}>Save</button>

                    <button className="cancel-button" onClick={()=>{setEditMrn(false);}}>Cancel</button>
                  </div>
                )}

            </div>
            <div className="d-flex justify-content-start my-4">
              <label style={{ width: "40%" }} className="muted-text">
                Physician
              </label>
              <div className="d-flex" style={{ width: "60%", gap: "10px" }}>
                <label style={{ gap: "5px" }}>
                  {singlePatientData?.physician || "NA"}{" "}
                  <label
                    style={{
                      fontSize: "0.8vw",
                      color: "#000000",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      showAssignPhysicianModal(true);
                    }}
                  >
                    | Assign
                  </label>
                </label>
              </div>
            </div>
            {process?.env.REACT_APP_DASHBOARD_TYPE === "youth" && (
              <>
                <div className="d-flex justify-content-start my-4">
                  <label style={{ width: "40%" }} className="muted-text">
                    Caregiver
                  </label>
                  <label style={{ width: "60%" }}>
                    {!isEmptyObject(caregiverData)
                      ? getFullName(caregiverData)
                      : "Not Assigned"}
                  </label>
                </div>
                {!isEmptyObject(caregiverData) && (
                  <div className="d-flex justify-content-start my-4">
                    <label style={{ width: "40%" }} className="muted-text">
                      Caregiver Email
                    </label>
                    <label style={{ width: "60%" }}>
                      {caregiverData?.email}
                    </label>
                  </div>
                )}
              </>
            )}
            <div className="d-flex justify-content-start my-4">
              <label style={{ width: "40%" }} className="muted-text">
                BH Diagnosis
              </label>
              <label style={{ width: "60%" }}>
                {/* {bhiData?.diagnosis || "Unavailable"} */}
                {singlePatientData?.bhi_eligible && singlePatientData?.bhi_enabled?bhiData?.diagnosis:"Unavailable"}
              </label>
            </div>
            <div className="d-flex justify-content-start my-4">
              <label style={{ width: "40%" }} className="muted-text">
                Patient Flag
              </label>
              <div className="d-flex" style={{ width: "60%", gap: "10px" }}>
                <SplitRiskPill
                  type={singlePatientData?.flag}
                  icon_type="flag"
                  icon_styles={{ cursor: "pointer" }}
                  styles={{ fontSize: "0.9rem", gap: "3px" }}
                  onClick={() => {
                    showResetFlagModal(true);
                  }}
                />
              </div>
            </div>
            {singlePatientData?.fire_flag?.length > 0 && (
              <div className="d-flex justify-content-start my-4">
                <label style={{ width: "40%" }} className="muted-text">
                  Urgent Risk
                </label>
                <div className="d-flex" style={{ width: "60%", gap: "10px" }}>
                  <SplitRiskPill
                    type={singlePatientData?.flag}
                    icon_type="flag"
                    custom_text={"URGENT RISK"}
                    icon_styles={{ cursor: "pointer" }}
                    styles={{ fontSize: "0.9rem", gap: "3px" }}
                    onClick={() => {
                      setIsModalOpen(true);
                    }}
                  />
                </div>
              </div>
            )}
            <div className="d-flex justify-content-start my-4">
              {/* <label style={{ width: "40%" }} className="muted-text">
                Chat Function
              </label> */}
              <div className="d-flex" style={{ width: "50%", gap: "10px" }}>
                <label className="switch">
                  <input
                    disabled={chatLoading}
                    onChange={() => {
                      handleChatToggle();
                    }}
                    checked={chatStatus}
                    type="checkbox"
                  />
                  <span className="slider round"></span>
                </label>

                <strong
                  style={{
                    marginTop: "2%",
                    color: "#395e9d",
                    userSelect: "none",
                  }}
                >
                  Enable Chat
                  {/* {chatStatus ? "Enabled" : "Disabled"} */}
                </strong>
              </div>
              {process?.env.REACT_APP_DASHBOARD_TYPE === "youth" ? (
                <div className="d-flex" style={{ width: "50%", gap: "10px" }}>
                  <label className="switch">
                    <input
                      disabled={ssriLoading}
                      onChange={() => {
                        handleSSRIToggle();
                      }}
                      checked={ssriStatus}
                      type="checkbox"
                    />
                    <span className="slider round"></span>
                  </label>

                  <strong
                    style={{
                      marginTop: "2%",
                      color: "#395e9d",
                      userSelect: "none",
                    }}
                  >
                    {/* {chatStatus ? "Enabled" : "Disabled"} */}
                    SSRI
                  </strong>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      )}
    </CardLayout>
  );
};
export default BasicInformation;
